import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import styles from './controls.module.css';
/**
 * Text field.
 *
 * Replaces `.signin-input`, which was a sign-in control (full width, bottom
 * margin) borrowed by 28 other screens. Width belongs to the layout, not to
 * the field, so it is not set here.
 *
 * `error` wins over `hint` and is wired through aria-describedby, matching the
 * behaviour the accessibility suite already asserts for SettingsField.
 */
export function Input({ label, hint, error, id, className, ...rest }) {
    const auto = useId();
    const fieldId = id ?? auto;
    const noteId = `${fieldId}-note`;
    const note = error ?? hint;
    return (_jsxs("span", { className: styles.field, children: [label ? (_jsx("label", { className: styles.label, htmlFor: fieldId, children: label })) : null, _jsx("input", { id: fieldId, className: [styles.control, error ? styles.invalid : '', className ?? '']
                    .filter(Boolean)
                    .join(' '), "aria-invalid": error ? true : undefined, "aria-describedby": note ? noteId : undefined, ...rest }), note ? (_jsx("span", { id: noteId, className: error ? styles.error : styles.hint, children: note })) : null] }));
}
/** Select. Replaces 50 bare <select> elements wearing user-agent styling. */
export function Select({ label, hint, error, id, className, children, ...rest }) {
    const auto = useId();
    const fieldId = id ?? auto;
    const noteId = `${fieldId}-note`;
    const note = error ?? hint;
    return (_jsxs("span", { className: styles.field, children: [label ? (_jsx("label", { className: styles.label, htmlFor: fieldId, children: label })) : null, _jsx("select", { id: fieldId, className: [styles.control, styles.select, error ? styles.invalid : '', className ?? '']
                    .filter(Boolean)
                    .join(' '), "aria-invalid": error ? true : undefined, "aria-describedby": note ? noteId : undefined, ...rest, children: children }), note ? (_jsx("span", { id: noteId, className: error ? styles.error : styles.hint, children: note })) : null] }));
}
//# sourceMappingURL=Input.js.map